export enum ReportMessageType {
	INCOMING = 'incoming',
	OUTGOING = 'outgoing',
}

export enum ReportState {
	ACTIVE = 'active',
	CLOSED = 'closed',
	COMPLETED = 'completed',
}

export interface IReport {
	id: string;
	characterId: string;
	accountId?: string;
	playerName?: string;
	state: ReportState;
	isHelpNeeded: boolean;
	playerOnline: boolean;
	lastMessage?: string;
	lastMessageIsFromStaff?: boolean;
	createdAt: number;
	viewingStaff?: string[];
	participants?: string[];
}

export interface IReportMessage {
	id: string;
	characterId: string;
	accountId?: string;
	playerName?: string;
	message: string;
	isStaffMessage: boolean;
	createdAt: number;
}
